<h1 mat-dialog-title>New Task</h1>

<div mat-dialog-content class="task-create-dialog-content">
    <div [class.hidden]="hasCustomer()" class="pick-customer">
        <button type="button" (click)="openCustomerSearch()" matRipple apStatus="Add a customer to this task" accent="" mat-raised-button>
            <mat-icon>person_add</mat-icon> Add a customer
        </button>
    </div>

    <div *ngIf="hasCustomer()" class="customer">
        <div class="customer-details">
            <div class="name">{{newTask.customer?.name}}</div>
            <div class="phone"><span [apPhone]="newTask.customer?.phone">{{newTask.customer?.phone | phone}}</span></div>
        </div>

        <div class="customer-buttons">
            <button type="button" (click)="editCustomer()" mat-button>Edit</button>
            <button type="button" (click)="chooseDifferentCustomer()" mat-button>Choose different</button>
        </div>
    </div>

    <mat-form-field class="subject" appearance="outline">
        <mat-label>Device name</mat-label>
        <input [(ngModel)]="newTask.subject" matInput maxlength="60" required>
    </mat-form-field>

    <mat-form-field class="description" appearance="outline">
        <mat-label>Work required</mat-label>
        <textarea [(ngModel)]="newTask.description" matInput required cdkTextareaAutosize cdkAutosizeMinRows="5" cdkAutosizeMaxRows="10"></textarea>
    </mat-form-field>
</div>

<div mat-dialog-actions align="end">
    <button mat-dialog-close mat-button>Cancel</button>
    <button type="button" (click)="createTask()" [disabled]="isSaving || !canCreateTask()" color="primary" mat-raised-button>
        {{ isSaving ? 'Creating...' : 'Create Task' }}
    </button>
</div>
